// Copyright (c) Move Closer 2022.
import { __decorate } from "tslib";
import { Injectable } from '@movecloser/front-core';
let SupportedFormatsMiddleware = class SupportedFormatsMiddleware {
    constructor() {
        this.supportedFormats = null;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    afterCall(response, resource) {
        // Do nothing
    }
    beforeCall(resource, headers, body) {
        var _a;
        headers['X-Browser-Accept'] = (_a = this.supportedFormats) !== null && _a !== void 0 ? _a : '';
        return { headers, body };
    }
    hasSupportedFormats() {
        return this.supportedFormats !== null;
    }
    setSupportedFormats(formats) {
        this.supportedFormats = formats;
    }
};
SupportedFormatsMiddleware = __decorate([
    Injectable()
], SupportedFormatsMiddleware);
export { SupportedFormatsMiddleware };
export const SupportedFormatsMiddlewareType = Symbol.for('ISupportFormats');
